<template>
    <div class="price-tag-discount" :class="{ 'price-tag-discount--inverted': inverted }">
        <slot>{{ prefix }}{{ formatPercent(percent) }}</slot>
    </div>
</template>

<script setup>
import { usePriceTagText } from '@/js/composables/usePriceTagText';

defineProps({
    percent: {
        type: Number,
        default: null,
    },
    prefix: {
        type: String,
        default: '',
    },
    inverted: {
        type: Boolean,
        default: false,
    },
});

const { formatPercent } = usePriceTagText();
</script>

<style lang="scss" scoped>
.price-tag-discount {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    align-self: flex-start;
    background: var(--price-tag-accent);
    color: var(--price-tag-accent-text);
    border-radius: 0.6rem;
    padding: 0.6rem 1.4rem;
    font-size: 4.8rem;
    font-weight: 900;

    &--inverted {
        background: transparent;
        color: inherit;
        padding: 0;
    }
}
</style>
